var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('h2',{staticClass:"page-titles"},[_vm._v("Projects")]),_c('projectsList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }